import React from "react";
import { useQuery } from "@apollo/client";
import { useLocation, useParams } from "react-router-dom";
import AddNewRecipe from "./AddNewRecipe";
import { gql } from "@apollo/client";
import { CircularProgress, Typography } from "@mui/material";
import {
  RecipeValidationProvider,
  useRecipeValidation,
} from "../Context/RecipeValidationContext";
import LoadingPage from "./LoadingPage";
import ErrorPage from "./ErrorPage";

const GET_RECIPE_BY_ID = gql`
  query GetRecipeById($id: ID!) {
    recipe(id: $id)
  }
`;

export default function EditRecipePage() {
  const { recipe_id } = useParams();
  const location = useLocation(); // Access the current location

  // Parse query parameters
  const queryParams = new URLSearchParams(location.search);
  const msg = queryParams.get("msg");

  console.log("Recipe ID:", recipe_id);
  console.log("Message:", msg);
  const { data, loading, error } = useQuery(GET_RECIPE_BY_ID, {
    variables: { id: recipe_id },
  });

  // Check if the recipe exists and if validation data is available
  const isValid = useRecipeValidation(parseInt(recipe_id));

  if (loading) return <LoadingPage />;

  if (error) return <ErrorPage message="Error loading recipe data" />;

  // Check if the recipe is null or undefined
  if (!data || !data.recipe) {
    return (
      <ErrorPage message={"Your requested recipe not found in our database!"} />
    );
  }

  const recipe =
    data.recipe && typeof data.recipe === "string"
      ? JSON.parse(data.recipe)
      : data.recipe;
  console.log("recipeeeee", recipe);

  const defaultValues = {
    ...recipe.recipe,
    nutrition: { ...recipe.nutrition },
  };

  return (
    <RecipeValidationProvider
      recipe_id={parseInt(recipe?.recipe?.id)}
      key={recipe?.recipe?.id}
    >
      <AddNewRecipe
        defaultValues={defaultValues}
        isAuthor={isValid?.isAuthor}
        isDownloaded={msg === "Download"}
      />
    </RecipeValidationProvider>
  );
}
